export default {"src":"/_next/static/media/fire.edf978cc.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};